import { Nav } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/home', icon: 'bi-house-door-fill', label: 'Home' },
    { path: '/markets', icon: 'bi-bar-chart-fill', label: 'Markets' },
    { path: '/option', icon: 'bi-bullseye', label: 'Option' },
    { path: '/exchange', icon: 'bi-arrow-left-right', label: 'Exchange' },
    { path: '/assets', icon: 'bi-briefcase-fill', label: 'Assets' },
  ];

  const isActive = (path) => location.pathname === path;

  // Handle navigation with authentication check for certain routes
  const handleNavClick = (path) => {
    if (path === '/assets' || path === '/option' || path === '/exchange') {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('Please Login First', {
          position: 'bottom-left',
          autoClose: 3000,
        });
        return;
      }
    }
    navigate(path);
  };

  return (
    <Nav
      className='fixed-bottom d-flex justify-content-around align-items-center'
      style={{
        background:
          'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.98) 100%)',
        boxShadow: '0 -2px 20px rgba(0,0,0,0.06)',
        height: '68px',
        padding: '0 16px',
        borderTop: '1px solid rgba(102, 126, 234, 0.1)',
        backdropFilter: 'blur(20px)',
        zIndex: 1000,
      }}
    >
      {navItems.map((item) => {
        const active = isActive(item.path);

        return (
          <Nav.Item key={item.path} style={{ flex: 1, maxWidth: '80px' }}>
            <Nav.Link
              as='div'
              className='text-center d-flex flex-column align-items-center justify-content-center'
              onClick={() => handleNavClick(item.path)}
              style={{
                cursor: 'pointer',
                color: active ? '#667eea' : '#9CA3AF',
                transition: 'all 0.25s ease',
                padding: '8px 4px',
                borderRadius: '14px',
                position: 'relative',
                height: '56px',
              }}
              onMouseEnter={(e) => {
                if (!active) {
                  e.currentTarget.style.color = '#667eea';
                  e.currentTarget.style.backgroundColor =
                    'rgba(102, 126, 234, 0.04)';
                }
              }}
              onMouseLeave={(e) => {
                if (!active) {
                  e.currentTarget.style.color = '#9CA3AF';
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
            >
              {active && (
                <div
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '32px',
                    height: '3px',
                    background:
                      'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '0 0 3px 3px',
                  }}
                />
              )}
              <i
                className={`bi ${item.icon}`}
                style={{
                  fontSize: active ? '1.35rem' : '1.25rem',
                  marginBottom: '4px',
                  transition: 'all 0.25s ease',
                }}
              ></i>
              <div
                style={{
                  fontSize: '0.7rem',
                  fontWeight: active ? '600' : '500',
                  letterSpacing: '0.2px',
                  marginTop: '2px',
                }}
              >
                {item.label}
              </div>
            </Nav.Link>
          </Nav.Item>
        );
      })}
    </Nav>
  );
};

export default BottomNav;
